/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkExportDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkExportDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkSelectDeselectDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkSelectDeselectDto';
import type { Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkSendSignUpLinkResponseDto } from '../models/Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkSendSignUpLinkResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantFilterService {

    /**
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkExportDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantFilterBulkExportParticipantByFilter(
requestBody?: Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkSelectDeselectDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkExportDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant-filter/bulk-export-participant-by-filter',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param signUpType 
     * @param requestBody 
     * @returns Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkSendSignUpLinkResponseDto OK
     * @throws ApiError
     */
    public static postApiCustomerApiAppParticipantFilterBulkSendParticipantSignUpLinkByFilter(
signUpType?: string,
requestBody?: Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkSelectDeselectDto,
): CancelablePromise<Wealthlane_CustomerService_Dtos_Participant_ParticipantBulkSendSignUpLinkResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/customer/api/app/participant-filter/bulk-send-participant-sign-up-link-by-filter',
            query: {
                'signUpType': signUpType,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
